import { createContext } from "preact";

// The current theme ('light' or 'dark') and a function to switch themes will be stored here.
export const ThemeContext = createContext({
  theme: "light",
  switchTheme: () => {},
});
